import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@softline/ui-core';
import { Auftrag } from '../../../types/auftrag';

@Component({
  selector: 'soft-tp-card',
  imports: [DatePipe, TranslatePipe],
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {
  private readonly router = inject(Router);

  readonly auftrag = input<Auftrag | null>(null);

  async openAuftrag(auftrag: Auftrag): Promise<void> {
    await this.router.navigate(['/energietransport', auftrag.id]);
  }
}
